import type { StepperStep } from '@tasama/ui';

// Default step routes for most company types
export const defaultStepRoutes = [
  '/',
  '/your-details',
  '/upload-documents',
  '/company-details',
  '/service-needs',
  '/confirmation',
];

// Step routes for PIF projects (project-details instead of company-details)
export const pifProjectStepRoutes = [
  '/',
  '/your-details',
  // Below step is not required
  // '/upload-documents',
  '/project-details',
  '/service-needs',
  '/confirmation',
];

// Function to get default steps with translations
export const getDefaultSteps = (t: (_key: string) => string): StepperStep[] => [
  {
    id: 'company-type',
    label: t('navigation.steps.companyType'),
  },
  {
    id: 'your-details',
    label: t('navigation.steps.yourDetails'),
  },
  {
    id: 'upload-documents',
    label: t('navigation.steps.uploadDocuments'),
  },
  {
    id: 'company-details',
    label: t('navigation.steps.companyDetails'),
  },
  {
    id: 'service-needs',
    label: t('navigation.steps.serviceNeeds'),
  },
];

// Function to get PIF project steps with translations
export const getPifProjectSteps = (
  t: (_key: string) => string
): StepperStep[] => [
  {
    id: 'company-type',
    label: t('navigation.steps.companyType'),
  },
  {
    id: 'your-details',
    label: t('navigation.steps.yourDetails'),
  },
  // Below step is not required
  // {
  //   id: 'upload-documents',
  //   label: t('navigation.steps.uploadDocuments'),
  // },
  {
    id: 'project-details',
    label: t('navigation.steps.projectDetails'),
  },
  {
    id: 'service-needs',
    label: t('navigation.steps.serviceNeeds'),
  },
];

export const stepPathMap: Record<string, string> = {
  'company-type': '/',
  'your-details': '/your-details',
  'upload-documents': '/upload-documents',
  'company-details': '/company-details',
  'project-details': '/project-details',
  'service-needs': '/service-needs',
  confirmation: '/confirmation',
};
